import React from "react"
import Title from "./Title"
import { FaAngleDoubleRight } from "react-icons/fa"
import { graphql, useStaticQuery } from "gatsby"
import { Link } from "gatsby"

const Jobs = () => {
  const data = useStaticQuery(query)
  const {allStrapiJob:{nodes:jobs}} = data
  const [value, setValue] = React.useState(0)
  const {company, position, date, description} = jobs[value]
  return (
    <section className="section jobs">
      <Title title='Experience'/>
      <div className="jobs-center">
        <div className="btn-container">
          {jobs.map((item, index) => {
            return(
              <button className={index === value? "job-btn active-btn": "job-btn"} key={index} onClick={() => setValue(index)}>
              {item.company}</button>
            )
          })}
        </div>
        <article className="job-info">
          <h3>{position}</h3>
          <h4>{company}</h4>
          <p className="job-date">{date}</p>
          {description.map((item) => {
            return (
              <div className="job-desc" key={item.id}>
                <FaAngleDoubleRight className="job-icon"></FaAngleDoubleRight>
                <p>{item.name}</p>
              </div>
            )
          })}
        </article>
      </div>
      <Link to="/about" className="btn center-btn">more info</Link>
    </section>
    )
}

const query = graphql`
{
  allStrapiJob(sort: {fields: created_at, order: DESC}) {
    nodes {
      company
      date
      description {
        id
        name
      }
      position
    }
  }
}

`

export default Jobs
